import React from 'react';
import {blueGrey} from '@mui/material/colors'
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import {Card,Backdrop,CircularProgress, CardActions,IconButton, CardMedia,Link, Box, CardHeader, CardContent,Paper,Alert,Snackbar, Grid, Slider,Icon, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Switch, Accordion, AccordionDetails, AccordionSummary, Avatar, Button, Chip,  Divider,  Badge, Stack, Typography,TextField, Checkbox, StyledEngineProvider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {DirectionsRunOutlined, DirectionsWalkOutlined, PedalBikeOutlined, PoolOutlined, FitnessCenterOutlined, Label, DirectionsRun, DirectionsBikeOutlined} from '@mui/icons-material';
import { useState } from "react";
import { savePreferences } from '../services/api';
import { GetWeekNumber, limitString } from './EMCUtils';
import { ReactComponent as Spring } from "../img/spring-new.svg";
import { ReactComponent as Summer } from "../img/summer-new.svg";
import { ReactComponent as Autumn } from "../img/autumn-new.svg";
import { ReactComponent as Winter } from "../img/winter-new.svg";
import Strava_Logo from '../img/strava_symbol_orange.png'
import SvgIcon from "@mui/material/SvgIcon";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseIcon from '@mui/icons-material/Close';
import {Favorite} from "@mui/icons-material";
import {EventCard} from './EventCard';

import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { useNavigate } from 'react-router-dom' ;

  /*import SportsScoreIcon from '@mui/icons-material/SportsScore';
  * Renders a badge with associated points. Takes 3 parameters 
  * icon - Unicode text representing the icon
  * variant - Typography variant that determines the size of the icons rendered
  * points - Points to display on the badge
  */
  const BadgeWithPoints = ({icon, variant, points,  }) => {
        if (points == 0) {
            return <></>
        }
        return(
            <Badge badgeContent={points} color="primary" max={5000}  anchorOrigin={{ vertical: 'top', horizontal: 'right', }}>
              <Typography variant={variant} color="text.secondary">
                {icon}
              </Typography>
            </Badge>
        ) ;

  }

  /*
  * Utility function to render a single summary item takes in 3 parameters
  * summary - the JSON representing the Summary item - could be weekly or annual doesnt matter
  * item - Primary used for displaying week number in the beginning of the row, Can be null so nothing will be displayed
  * target - The target for individual user - used to determine the color in which the total is displayed.
  */
  const RenderSummaryItem = ({summary, item, target}) => {
    var color = summary.Total >= target ? "success" : summary.Total >= target/2 ? "warning" : "error" ;
    var avatar = (item!= null)?<Avatar sx={{ bgcolor: blueGrey[500], width: 24, height: 24 }}>{item}</Avatar> : <></> 
    return (
      <Grid container sx={{border:'0px dotted black'}} >
        <Grid item xs={10}>
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                  {avatar}
                  <RenderActivityDetailsChipInStack Summary={summary}/>
          </Stack>
        </Grid>
        <Grid item xs={2} alignItems="flex-end" justifyContent="flex-end">
               <Chip label={summary.Total} color={color} variant="filled" sx={{alignContent:'flex-end'}} />
        </Grid>
      </Grid>

    );
  }


  const RenderAthleteDetails = ({item, target}) => {
    return(
      <Grid container sx={{border:'0px dotted black'}} >
        <Grid item xs={2}>
              <Avatar src={item.picture}></Avatar>
        </Grid>
        <Grid item xs={8}>
            <Typography variant="subtitle1"> {item.name} </Typography>
        </Grid>
        <Grid item xs={2} alignItems="flex-end" justifyContent="flex-end">
                <BadgeWithPoints icon="🏁" variant="h5" points = {target} />
        </Grid>
      </Grid>

    );

  }

  export const RenderSummaryItemForDashboard= ({item,type}) => {
    //console.log(GetWeekNumber());
    var targetpoints = type === "Weekly" ? item.prefs.targetpoints : item.prefs.targetpoints*(GetWeekNumber()-1)
    var color = item.Summary.Total >= targetpoints ? "success" : item.Summary.Total>=targetpoints/2 ? "warning": "error" ;

    return(
    <Card sx={{border:'0px dotted black', p:0.5}}>
      <CardHeader  sx={{border:'0px dotted black', p:0.5}}
        avatar={
          <Avatar aria-label="recipe" src={item.picture}>
            R
          </Avatar>
        }
        title={item.name}
        subheader = {"🏁" + targetpoints }  
      />
        <Grid container sx={{border:'0px black' }}>
        <Grid item xs={10}sx={{border:'0px dotted black', display:'flex', alignItems:'center',justifyContent:'flex-start'}}>
          <RenderActivityDetailsChipInStack Summary={item.Summary}/>
        </Grid>
        <Grid item xs={2} sx={{border:'0px dotted black',display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Chip size="small" label={item.Summary.Total} color={color} variant="filled" sx={{alignContent:'flex-end'}} />
        </Grid>
        </Grid>
    </Card>
    );
  }

  const RenderActivityDetailsBadgeInStack = ({Summary}) => {
           return(
            <Stack direction="row" justifyContent="flex-start" spacing={4}>
                    <BadgeWithPoints icon="🏃" variant="h6" points = {Summary.Run} />
                    <BadgeWithPoints icon="🚶"variant="h6" points = {Summary.Walk} />
                    <BadgeWithPoints icon="🚴" variant="h6" points = {Summary.Ride} />
                    <BadgeWithPoints icon="🏊" variant="h6" points = {Summary.Swim} />
                    <BadgeWithPoints icon="🤸" variant="h6" points = {Summary.Others} />
            </Stack>
           );
  }
  
  const RenderActivityDetailsChipInStack = ({Summary}) => {
           return(
            <Stack direction="row" justifyContent="flex-start" spacing={1}>
              {Summary.Run > 0 ?<Chip size="small" icon={<DirectionsRunOutlined/>} label= {Summary.Run} /> : <></>}
              {Summary.Walk > 0? <Chip size="small" icon={<DirectionsWalkOutlined/>} label = {Summary.Walk} /> : <></>}
              {Summary.Ride >0 ?<Chip size="small" icon={<PedalBikeOutlined/>} label = {Summary.Ride} /> :<></> }
              {Summary.Swim >0 ? <Chip size="small" icon={<PoolOutlined/>} label = {Summary.Swim} /> : <></>}
              {Summary.Others>0 ?<Chip size="small" icon={<FitnessCenterOutlined/>} label = {Summary.Others} /> : <></> }
            </Stack>
           );
  }
  /*
  /*
  * Renders the weekly summary accordion for user. Iterates through the array and renders one row per week
  */
 export const RenderUserWeeklySummary = ({SummaryList, Target}) => {
    return(
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Weekly Summary</Typography>
            </AccordionSummary>
            <Divider/>
            <AccordionDetails sx={{p:2}}>
              <Stack spacing={1} justifyContent="flex-start" direction="column-reverse" alignItems="center">
              {SummaryList.map(w => <RenderSummaryItem  summary={w.Summary} key={w.Week} item={w.Week} target={Target}/>) }
              </Stack>
            </AccordionDetails>
          </Accordion>
    );

  }


  const RenderSummary =  ({Title , Summary, Target}) =>{
     return(
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
            <Typography>{Title}</Typography>
            </AccordionSummary>
            <Divider/>
            <AccordionDetails sx={{p:1}}>
              <Stack spacing={0.1} sx={{border:'0px solid  black'}} justifyContent="flex-start" direction="column-reverse" alignItems="center">
                <RenderSummaryItem summary = {Summary}  key={Summary.Total} target= {Target}/>
              </Stack>
            </AccordionDetails>
          </Accordion>
    );
   
  }
  /*
  * Renders the annual summary accordion for user. The yearly target is determined by multiplying the target by number of weeks passed from the weekly array.
  */
export  const RenderUserAnnualSummary = ({Summary, Target}) => {
    return(

            <RenderSummary Title="Annual Summary" Summary={Summary} Target={Target} ></RenderSummary>
    );

  }

  /*
  * Renders the user preferences
  * TODO: Add functionality to update preferences and save them.
  */

  export  const RenderPreferences = ( {id,prefs}) => {
    const vertical='top';
    const horizontal='center';
    const [p, setP] = useState(prefs);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const handleClick = () => {
      setOpen(true);
      setLoading(false);
    };
  
    const handleClose = () => {
      setOpen(false);
      setLoading(false);
    };

    const handleSubmit = async (evt) => {
        setLoading(true);
        evt.preventDefault();
        await savePreferences(id, p).
        then (res => handleClick());
        
    }
    const handleChange = (event,prop) => {
      // If any of the boxes are checked we also need to check the active button to true
      if (event.target.checked)
        setP({...p,[prop]:event.target.checked, active:true});
      else
        setP({...p,[prop]:event.target.checked});
    };
    /*
    const handleTextChange = (event,prop) => {
      setP({...p,[prop]:event.target.value});
    };
    */
    const handleChangePoints = (event) => {
      console.log(event.target.value);
      setP({...p,targetpoints:event.target.value});
    };
   // const marks = [50,75,100,125,150,175,200,225,250,275,300].map(x =>{ value:x});
    
    return (
      <>
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{vertical:'top',horizontal:'center'}}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Preferences Saved
        </Alert>
      </Snackbar>
      <Snackbar open={loading} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{ vertical:'top',horizontal:'center'}}>
        <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }}>
          Saving Preferences!!!
        </Alert>
      </Snackbar>
      
      <form onSubmit={handleSubmit}>
        <Paper sx={{ p: 5 }}>
          <Stack spacing={4} justifyContent="flex-start" direction="column-reverse" alignItems="center">
            <FormGroup sx={{ width: '90%' }}>
              <FormControlLabel control={<Checkbox onChange={(e) => handleChange(e, 'active')} checked={p.active} />} label="Active" />
              <FormControlLabel control={<Checkbox onChange={(e) => handleChange(e, 'springchallenge')} checked={p.springchallenge} />} label="Spring Challenge" />
              <FormControlLabel control={<Checkbox onChange={(e) => handleChange(e, 'summerchallenge')} checked={p.summerchallenge} />} label="Summer Challenge" />
              <FormControlLabel control={<Checkbox onChange={(e) => handleChange(e, 'autumnchallenge')} checked={p.autumnchallenge} />} label="Autumn Challenge" />
              <FormControlLabel control={<Checkbox onChange={(e) => handleChange(e, 'winterchallenge')} checked={p.winterchallenge} />} label="Winter Challenge" />
              <Typography variant="h6" component="div" gutterBottom> Weekly Target  </Typography>
              <Typography variant="h1" component="div" gutterBottom> </Typography>
              
              <FormControlLabel control={
              <Slider
                value={p.targetpoints}
                onChange={handleChangePoints}
                min={50}
                step={25}
                marks={true}
                max={300}
                valueLabelDisplay="on"
                aria-labelledby="non-linear-slider"
              />} label="" />
              
              <Button xs={12} lg={4} xl={2} variant="contained" type="submit">Save Preferences</Button>
            </FormGroup>
          </Stack>
        </Paper>
      </form>
      </>
    );
  }

export const RenderSeasonalSummaryRow =({item}) => {
  //console.log(item);
  return (
    <Card sx={{border:'0px dotted black', p:0.5}}>
      <CardHeader  sx={{border:'0px dotted black', p:0.5}}
        avatar={
          <Avatar aria-label="recipe" src={item.picture}>
            R
          </Avatar>
        }
        title={item.name}
        subheader = {"🏁" + item.prefs.targetpoints }  
      />
          <RenderWeeklyScoresForDashboard items={item.Summary} target={item.prefs.targetpoints} total={item.Total} totaltarget={item.totaltarget}/>
    </Card>
  );
}
/*
export const RenderActivity =({item}) => {
  return (
    <Card sx={{border:'0px dotted black', p:0.5}}>
      <CardHeader  sx={{border:'0px dotted black', p:0.5}}
        avatar={
          <Avatar aria-label="recipe" src={item.pic}>
            R
          </Avatar>
        }
        title={item.name}
        subheader = { item.Type}
      />
      <Grid sx={{display:'flex', border:'0px dashed grey'}}  container>
        <Grid sx={{display:'flex', alignItems:'center' ,border:'0px dashed grey'}} xs={10} item container>
          {item.Title}
          {item.Duration}
          {item.Distance}
          {item.Date}
        </Grid>
        <Grid sx={{display:'flex', justifyContent:'flex-end', border:'0px dashed grey'}} xs={2} item container>
        </Grid>
      </Grid> 
    </Card>
  );
}*/

export const RenderValueInCircle = ({value, label}) => {
  return  (
    <Typography variant="subtitle2">
      {label}  {value}
    </Typography>
  );

}

export const RenderActivity = ({item}) => {
  return (
  <Card variant="outlined" sx={{  border: '0px dotted gray' }}>
          <Stack direction="row">
            <CardHeader  sx={{width:'60%', border:'0px dotted black', p:0.5}}
              avatar={ <Avatar aria-label="recipe" src={item.pic}/> }
              title={limitString(item.name,18)}
              subheader = { item.Title}
            />
            <CardHeader  sx={{width:'20%', border:'0px dotted black', p:0.5}}
              title={getIconForType(item.Type)}
            />
            {/*
            <Icon fontSize="small" sx={{ p:2, width:'10%', border:'0px dotted black'}}> <span class="material-icons"> thumb_up_off_alt </span> </Icon>
            */}
          </Stack>
          <Stack direction="row">
          </Stack>
          <Stack spacing={1}  sx={{display:'flex'}}  divider={<Divider orientation="vertical" flexItem />} direction="row">
          <RenderValueInCircle value={item.Distance} label="📏"/>
          <RenderValueInCircle value={convertMinutesToTime(item.Duration)} label="⏲"/>
          <RenderValueInCircle value={item.Points} label="💯"/>
          <RenderValueInCircle value={item.Date} label="📅"/>
          </Stack>
          <Stack spacing={1}  sx={{display:'flex'}}  divider={<Divider orientation="vertical" flexItem />} direction="row">
          </Stack>
    </Card>
  );
}

const getIconForType = (type) => {
  switch (type) {
    case 'Run' :
      return <span class="material-icons">directions_run</span>;
    case 'Ride' :
      return <span class="material-icons">directions_bike</span>;
    case 'VirtualRide' :
      return <span class="material-icons">directions_bike</span>;
    case 'EBikeRide' :
      return <span class="material-icons">electric_bike</span>;
    case 'Walk' :
      return <span class="material-icons">directions_walk</span> ;
    case 'Swim' :
      return <span class="material-icons">pool</span> ;
    case 'Workout' :
      return <span class="material-icons">fitness_center</span> ;
    case 'Yoga' :
      return <span class="material-icons">self_improvement</span> ;
    default :
      return <span class="material-icons">fitness_center</span>;
  }
}

const RenderWeeklyScoresForDashboard = ({items,target, total, totaltarget }) => {
  //console.log(totaltarget);
  var weeklychips= items.map (item => <Grid item xs={2}> <RenderTargetBasedChip value={item.Summary.Total} target={target} variant="outlined"  size="small"></RenderTargetBasedChip> </Grid>);
  //weeklychips = <Stack direction="row" justifyContent="flex-start" spacing={0.5}> {weeklychips} </Stack>
  //weeklychips = <Stack direction="row" justifyContent="flex-start" spacing={0.5}> {weeklychips} </Stack>
  var totalchip =  <RenderTargetBasedChip value={total} target={totaltarget} variant="filled" size="large"/>
//  totalchip = <Stack direction="row" justifyContent="flex-end" spacing={0.5}> {totalchip} </Stack>
  return(
  <Grid sx={{display:'flex', border:'0px dashed grey'}}  container>
    <Grid sx={{display:'flex', alignItems:'center' ,border:'0px dashed grey'}} xs={10} item container>
      {weeklychips}
    </Grid>
    <Grid sx={{display:'flex', justifyContent:'flex-end', border:'0px dashed grey'}} xs={2} item container>
      {totalchip}
    </Grid>
  </Grid>
  );
  return (<Stack direction="row"  spacing={0.5}>{weeklychips} {totalchip}</Stack>);
  
}

const RenderTargetBasedChip = ({value, target, variant, size} ) => {
  const color = (value>=target) ? "success" : (value >= target/2) ? "warning" : "error"; 
  return <Chip variant={variant} size={size} label={value} color={color}></Chip> 
}



export const RenderDashboardHeader = ({maintext, subtext}) => {
  return(
    <Grid container sx={{border:'0px solid blue', pb:0.1}} >
        <Grid item xs={12}>
            <Paper elevation={3} sx={{textAlign: 'center', width:'100%'}} >
              <Typography variant="h6" sx={{ bgcolor: 'text.primary', color: 'info.contrastText', p: 0.2 }}> 
                {maintext}
              </Typography>
              <Typography variant="subtitle1" sx={{ bgcolor: 'text.primary', color: 'info.contrastText', p: 0 }}> 
                {subtext}
              </Typography>
            </Paper>
        </Grid>
    </Grid>
  );
}


const SeasonalIcon = ( {season, active}) => {
  let icon = <QuestionMarkIcon/>;
  let color = active ? "success" : "error" ;
  switch (season) {
    case 'spring' : icon= <Badge color={color} variant="dot"> <SvgIcon> <Spring /> </SvgIcon> </Badge> 
    break ;
    case 'summer' : icon= <Badge color={color} variant="dot"> <SvgIcon > <Summer /> </SvgIcon> </Badge> 
    break ;
    case 'autumn' : icon= <Badge color={color} variant="dot"> <SvgIcon > <Autumn /> </SvgIcon> </Badge> 
    break ;
    case 'winter' :icon= <Badge color={color} variant="dot">  <SvgIcon > <Winter /> </SvgIcon> </Badge> 

    break ;
  }
  return icon;
}


export const RenderMember =({item}) => {
  const navigate=useNavigate();
  const ShowUserDashboard = (e, id) =>{
    navigate('/dashboard', {state : {id:id}})
  }
  return (
        <Paper>
      <Grid container sx={{border:'0px solid blue', m:0.5,p:0.5}} >
        <Grid item xs={2}>
                <Avatar aria-label="recipe" src={item.pic} onClick ={ (e) =>ShowUserDashboard(e,item.id)}/>
        </Grid>
        <Grid item xs={6}>
            <Stack >
              <Typography variant="subtitle1">{limitString(item.firstname + ' '+item.lastname, 15)}</Typography>
              <Typography variant="caption"> {"🏁" + item.prefs.targetpoints }</Typography>
            </Stack>
        </Grid>
        <Grid item xs={4}>
            <Stack sx={{p:0.5, pr:2, display:'flex', justifyContent:'flex-end'}}  direction="row" spacing={1} >
            <DirectionsRun fontSize="large" color={item.prefs.active?"success":"error"}/>
            <SeasonalIcon season='spring' active= {item.prefs.springchallenge}/>
            <SeasonalIcon season='summer' active= {item.prefs.summerchallenge}/>
            <SeasonalIcon season='autumn' active= {item.prefs.autumnchallenge}/>
            <SeasonalIcon season='winter' active= {item.prefs.winterchallenge}/>
            </Stack>
        </Grid>
      </Grid>
        </Paper>
  );
}

export const RenderUserActivities = ({activityList}) => {
  console.log(activityList);
     activityList.sort(reverseChronological);
     return(
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
            <Typography> Recent Activities </Typography>
            </AccordionSummary>
            <Divider/>
            <AccordionDetails sx={{p:1}}>
                <RenderActivityHeaderNarrow/>
              <Stack spacing={0.2} sx={{mt:0.5}} direction="column-reverse" alignItems="center">
                {activityList.map ( activity=> <RenderActivityNarrow activity = {activity} key={activity.id}/> )}
              </Stack>
            </AccordionDetails>
          </Accordion>
    );
}
/*
"Type": "Run",
        "Points": 37,
        "Title": "Evening run ",
        "Duration": "33.37",
        "id": 6482370128,
        "Week": 1,
        "Distance": "6.19",
        "Date": "2022-01-06"
*/
const RenderActivityNarrow = ({activity}) => {
  var stravalink = `https://www.strava.com/activities/${activity.id}`;
  return (
      <Paper sx={{width:"100%"}} elevation={1}>
  <Grid container columns={16} sx={{border:'0px dotted black'}} >
        <Grid item xs={4}>
          <Typography variant="body2">
            {activity.Date}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            {activity.Week}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body2">
            {activity.Type}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            {activity.Points}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            {convertMinutesToTime(activity.Duration)}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            {activity.Distance}
          </Typography> 
        </Grid>
        <Grid item xs={1}>
          <Link href={stravalink} underline="hover" target='_blank' rel='noopener'>
            <img alt=    "stravalink" width="25" height="25" src={Strava_Logo}/> 
          </Link>
        </Grid>
      </Grid>
      </Paper>
  );

}

const RenderActivityHeaderNarrow = ({activity}) => {
  return (
    <Paper sx={{width:'100%', border:'0.1px solid black'}}>
  <Grid container columns={16} sx={{p:0.25,border:'0px dotted black'}} >
        <Grid item xs={4}>
          <Typography variant="body2">
            📅
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            🗓
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body2">
            Type
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            💯
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            ⏲
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            📏㎞
          </Typography> 
        </Grid>
      </Grid>
      </Paper>
  );

}
const convertMinutesToTime = (t) => {
  t=Math.floor(t);
  var hours = Math.floor(t/60);
  var mins = Math.floor(t%60);
  var paddedmins = mins.toString().padStart(2,0);
  return `${hours}:${paddedmins}`;
}

const reverseChronological = (a,b) => {
  return a.Date > b.Date? 1 : a.Date < b.Date ? -1 : 0
}
export const WaitForData = ({show}) => {
  return (
          <Backdrop
            sx={{ color: '#bbb', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={show}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
  );
}

const LikeIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path d="M512,304.021c0-12.821-5.099-24.768-13.867-33.6c9.963-10.901,15.019-25.536,13.632-40.725
			c-2.475-27.115-26.923-48.363-55.616-48.363H324.395c6.485-19.819,16.939-56.149,16.939-85.333c0-46.272-39.317-85.333-64-85.333
			c-22.165,0-38.016,12.459-38.677,12.992c-2.539,2.048-3.989,5.099-3.989,8.341v72.32l-61.44,133.141l-2.56,1.28v-4.075
			c0-5.888-4.779-10.667-10.667-10.667H53.333C23.936,224,0,247.936,0,277.333V448c0,29.397,23.936,53.333,53.333,53.333h64
			c23.083,0,42.773-14.72,50.219-35.243c17.749,9.131,41.643,13.931,56.469,13.931H419.84c23.232,0,43.541-15.68,48.32-37.269
			c2.453-11.115,1.024-22.315-3.84-32.043c15.744-7.936,26.347-24.171,26.347-42.688c0-7.552-1.728-14.784-5.013-21.333
			C501.397,338.752,512,322.517,512,304.021z M149.333,448c0,17.643-14.379,32-32,32h-64c-17.664,0-32-14.357-32-32V277.333
			c0-17.643,14.357-32,32-32v0.107h95.957v10.667c0,0.064,0.043,0.107,0.043,0.171V448z M466.987,330.368
			c-4.117,0.469-7.595,3.264-8.896,7.211c-1.301,3.925-0.235,8.277,2.795,11.115c5.44,5.141,8.427,12.011,8.427,19.349
			c0,13.44-10.155,24.768-23.637,26.304c-4.117,0.469-7.595,3.264-8.896,7.211c-1.301,3.925-0.235,8.277,2.795,11.115
			c7.04,6.635,9.856,15.936,7.744,25.472c-2.624,11.883-14.187,20.523-27.499,20.523H224c-15.851,0-41.365-6.848-53.333-15.744
			V262.656l15.381-7.68c2.155-1.088,3.883-2.88,4.907-5.077l64-138.667c0.64-1.387,0.981-2.923,0.981-4.459V37.909
			c4.437-2.453,12.139-5.803,21.333-5.803c11.691,0,42.667,29.077,42.667,64c0,37.525-20.416,91.669-20.629,92.203
			c-1.237,3.264-0.811,6.955,1.195,9.835c2.005,2.88,5.269,4.608,8.789,4.608h146.795c17.792,0,32.896,12.715,34.389,28.971
			c1.131,12.16-4.672,23.723-15.168,30.187c-3.285,2.005-5.205,5.653-5.056,9.493c0.128,3.84,2.347,7.296,5.781,9.067
			c9.003,4.608,14.592,13.653,14.592,23.595C490.603,317.504,480.448,328.832,466.987,330.368z"/>  
    </SvgIcon>
  );
}

function HomeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );
}
